import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/imunizacao`

    const headers = { responseType: "arraybuffer" }

    return {
        registroVacinacao(id) {
            return repository.get(`${baseUrl}/registro-vacinacao/${id}`, headers)
        },
        carteiraVacinacao(id) {
            return repository.get(`${baseUrl}/carteira-vacinacao/${id}`, headers)
        },
        certidaoRegularidade(id) {
            return repository.get(`${baseUrl}/certidao-regularidade/${id}`, headers)
        },
        baixa(id) {
            return repository.get(`${baseUrl}/baixa/${id}`, headers)
        },
        distribuicao(id) {
            return repository.get(`${baseUrl}/distribuicao/${id}`, headers)
        },
        requisicao(id) {
            return repository.get(`${baseUrl}/requisicao/${id}`, headers)
        },
        relatorioDeAplicacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-de-aplicacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsolidadoAplicacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-consolidado-aplicacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPosicaoEstoque(queryParms) {
            return repository.get(`${baseUrl}/relatorio-posicao-estoque?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFaltosoAprazamento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-faltoso-aprazamento?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
